/* eslint-disable */

const BANNED = [
  "stupid", "idiot", "nonsense", "ridiculous", "pathetic", "lazy",
  "useless", "irresponsible", "lying", "lie", "lies", "liar",
  "dishonest", "fake", "fraud", "scam", "made up", "excuse",
  "excuses", "blame", "your fault", "negligent", "careless",
];

const WARNING = [
  "always", "never", "clearly", "obviously", "definitely",
  "wrong", "not true", "false", "unacceptable", "inappropriate",
  "bad", "poor", "angry", "upset", "keeps", "refuses",
];

export function analyseDecisionNote(note = "") {
  const text = String(note || "").toLowerCase();

  const blockedFlags = BANNED.filter((word) => text.includes(word));
  const warningFlags = WARNING.filter((word) => text.includes(word));

  const tone = blockedFlags.length
    ? "blocked"
    : warningFlags.length
      ? "warning"
      : "good";

  return {
    decisionTone: tone,
    decisionFlags: [...blockedFlags, ...warningFlags],
    decisionNoteLength: String(note || "").length,
    decisionGuidanceChecked: true,
  };
}